import AdceCTA from "@/components/adcelerate/CTA";
import AdceFooter from "@/components/adcelerate/Footer";
import Header from "@/components/adcelerate/Header";
import AdceHowItWorks from "@/components/adcelerate/HowItWorks";
import OurExpertise from "@/components/adcelerate/OurExpertise";
import Platforms from "@/components/adcelerate/Platforms";
import WhatWeDo from "@/components/adcelerate/WhatWeDo";
import WhoWeAre from "@/components/adcelerate/WhoWeAre";
import WhoDoWeDoItFor from "@/components/adcelerate/WhoWeDoItFor";
import { useEffect } from "react";

export default function AdcelerateMain() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      
      <>
        <Header />

        <Platforms partners={false} />

        <WhatWeDo />

        <WhoDoWeDoItFor />

        <AdceHowItWorks />

        <WhoWeAre />

        <OurExpertise />

        <Platforms partners={true} />

        <AdceCTA />

        <AdceFooter />
      </>
    </div>
  );
}
